import { render, staticRenderFns } from "./PortfolioItem.vue?vue&type=template&id=67d01fc9&scoped=true"
import script from "./PortfolioItem.vue?vue&type=script&lang=js"
export * from "./PortfolioItem.vue?vue&type=script&lang=js"
import style0 from "./PortfolioItem.vue?vue&type=style&index=0&id=67d01fc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d01fc9",
  null
  
)

export default component.exports